module.exports = __webpack_public_path__ + "static/media/k.96d75117.jpg";